import {AdminUser, LoginResponse, RequestDenied} from "../http/protocol";
import {
    handleForbiddenRequest,
    handleForceChangePassword,
    handleInvalidPasswordChange,
    handleLogin,
    handleLoginError,
    handleLoginSuccess,
    handleNotLoggedIn,
    handlePasswordChangeInProgress,
    handleResetForbiddenStatus
} from "../user/UserStore";
import {getContainer} from "../ioc/IOCSetup";



export class UserActions  {

    
    


    changePasswordAndLogin(username : string, password : string, newPassword : string){
        handlePasswordChangeInProgress();
        getContainer().getUserAuthenticationService().changePasswordAndLogin(username, password, newPassword).then( (r : LoginResponse) => {
            if(r.status === "SUCCESS") {
                this.loginResponse(r);
            } else {
                handleInvalidPasswordChange();
            }
        }).catch(e => {
            handleInvalidPasswordChange();
        });
    }
    login(username : string, password : string) {
        handleLogin();
        getContainer().getUserAuthenticationService().login(username,password).then(response => {
            this.loginResponse(response);
        }).catch( e => {
            console.log("Login failed", e);
            this.loginFailed();
        })
        return true;
    }
    logout() {
        getContainer().getUserAuthenticationService().logout().then(()=>{
            this.notLoggedIn();
        }).catch(()=>{
            this.notLoggedIn();
        });
        return true;
    }
    refreshToken(){
        getContainer().getUserAuthenticationService().refreshToken().then((response)=>{
            this.loginResponse(response);
        }).catch((e)=> {
            console.log("Login failed", e);
            this.loginFailed();
        });
        return true;
    }
    loginResponse(response : LoginResponse) {
        if(response.status === "PASSWORD_CHANGE_REQUIRED") {
            handleForceChangePassword();
        } else if(response.status === "INVALID_PASSWORD_CHANGE") {
            handleInvalidPasswordChange();
        } else if(response.status === "SUCCESS") {
            this.getUserInfo(true, response);
        } else {
            this.loginFailed();
        }
        return response;

    }
    getUserInfo( afterLogin? : boolean, userToken: LoginResponse = {}) {

        getContainer().getUserAuthenticationService().loadUserInfo().then(user => {
            getContainer().getUserAuthenticationService().getGroupPermissions().then(map=>{
                this.loginSuccess({user : user, permissions : map, userToken: userToken});
            });
        }).catch(e => {
            console.log("get user info error", this);
            console.log("Login error", e);
            handleNotLoggedIn();
        });
        return true;
    }
    requestForbidden(requestDenied: RequestDenied) {
        handleForbiddenRequest(requestDenied);
    }
    resetForbiddenStatus() {
        handleResetForbiddenStatus();
    }
    loginSuccess(wrapper : {user : AdminUser, permissions : { [key:string] : boolean}, userToken : LoginResponse}) {
        handleLoginSuccess(wrapper);
    }
    loginFailed() {
       handleLoginError();
    }
    notLoggedIn() {
        handleNotLoggedIn();
    }


}

